import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import '@/lib/zod-locale';
import { queryClient } from '@/lib/query-client';
import { createAppRouter } from '@/router';
import { Toaster } from '@/components/ui/sonner';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root introuvable');

const router = createAppRouter(queryClient);

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster />
    </QueryClientProvider>
  </StrictMode>,
);
